import { Link } from "react-router-dom";
import { categories, videos } from "@/mocks/videoData";

export default function CategoryShowcase() {
  const mainCategories = categories.slice(0, 4);

  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            视频分类
          </h2>
          <p className="text-sm text-foreground-600 mt-2">涵盖电影、电视剧、综艺、动漫等全品类资源</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4 mb-10">
          {categories.map((cat) => {
            const count = videos.filter((v) => v.category === cat.slug).length;
            const isPrimary = cat.slug === "movie" || cat.slug === "anime";
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group p-5 md:p-6 rounded-xl text-center transition-all cursor-pointer ${
                  isPrimary
                    ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                    : "bg-background-50 hover:bg-background-200"
                }`}
              >
                <span className={`w-12 h-12 flex items-center justify-center rounded-full mx-auto mb-3 ${
                  isPrimary ? "bg-background-50/20" : "bg-primary-100"
                }`}>
                  <i className={`${cat.icon} text-xl ${isPrimary ? "text-background-50" : "text-primary-500"}`}></i>
                </span>
                <h3 className={`text-sm font-semibold mb-1 ${isPrimary ? "text-background-50" : "text-foreground-950"}`}>
                  {cat.name}
                </h3>
                <p className={`text-xs ${isPrimary ? "text-background-50/70" : "text-foreground-500"}`}>
                  {count}+ 部资源
                </p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}